import React from 'react';
import { useIntl } from '@atlassian/jira-intl';
import { ErrorState as BaseErrorState } from '@atlassian/jira-issue-navigator-actions-common/src/ui/error/index.tsx';
import messages from './messages.tsx';

export const ErrorState = (): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<BaseErrorState description={formatMessage(messages.errorMessage)} pageAction="detailsPopup" />
	);
};
